export const DEFAULT_TIMEZONE = 'America/New_York';
